import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import Error404 from '../pages/error/Error404';
import ArogyaMitraLayout from '../layout/ArogyaMitraLayout';
import { NAVIGATE_CITIZEN } from '../constant';
import TermsConditions from '../pages/citizen/terms-condition';
import PrivacyPolicy from '../pages/citizen/privacy-policy';
import CopyrightPolicy from '../pages/citizen/copyright-policy';
import HyperlinkPolicy from '../pages/citizen/hyperlink-policy';
import Disclaimer from '../pages/citizen/disclaimer';


const RugnaMitraHomePage = lazy(() => import('../pages/citizen'));

const GuestRoute = () => {
    return (
        <Suspense fallback={<ArogyaMitraLayout><LoaderText /></ArogyaMitraLayout>}>
            <ArogyaMitraLayout>
                <Routes>
                    <Route path={NAVIGATE_CITIZEN.HOME} element={<RugnaMitraHomePage />} />
                    <Route path={NAVIGATE_CITIZEN.TERMS_CONDITIONS} element={<TermsConditions />} />
                    <Route path={NAVIGATE_CITIZEN.PRIVACY_POLICY} element={<PrivacyPolicy />} />
                    <Route path={NAVIGATE_CITIZEN.COPYRIGHT_POLICY} element={<CopyrightPolicy />} />
                    <Route path={NAVIGATE_CITIZEN.DISCLAIMER} element={<Disclaimer />} />
                    <Route path={NAVIGATE_CITIZEN.HYPERLINK_POLICY} element={<HyperlinkPolicy />} />
                    <Route path="*" element={<Error404 />} />
                </Routes>
            </ArogyaMitraLayout>
        </Suspense>
    );
};

export default GuestRoute;
